<template>
  <div class="generate-code-list">
    <div>
      <el-form ref="refGenerateForm" :model="productData" label-width="100px" inline>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="企业码">
              <el-input style="width: 100%;" v-model="productData.enterpriseCode" size="small" disabled
                        placeholder="企业码"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产品数量">
              <el-input v-model="productData.productCount" size="small" disabled placeholder="产品数量"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="规格型号">
              <el-input v-model="productData.productModel" size="small" disabled placeholder="规格型号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="生产订单">
              <el-input v-model="productData.orderNo" size="small" disabled placeholder="生产订单"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
         <div style="display: flex;flex-direction: row;flex-wrap: nowrap;justify-content: flex-start;align-items: center; padding:0px 20px">
           <el-form-item label="产品编码上传" prop="attachments" style="width: 25%;margin: 11px;">
             <el-upload
                 ref="upload"
                 class="upload"
                 :multiple="true"
                 :disabled="uploadDisabled"
                 :before-upload="handleBeforeUpload"
                 :action="uploadUrl"
                 :headers="headers"
                 :file-list="dialogCodeForm.excelFile"
                 :on-success="(response,file, fileList)=>handleQualityAptitudeSuccess(response,file, fileList,'excelFile')"
                 :on-remove="(file, fileList)=>handleQualityAptitudeRemove(file, fileList,'excelFile')"
                 :on-preview="handlePreviewDownload"
                 :on-change="onChangeFile">
               <i class="el-icon-upload"></i>
               <div class="el-upload__text"><em>点击上传</em></div>
             </el-upload>
           </el-form-item>
           <div class="span-line">
             <a href="https://static.shuibengcloud.com/upload/traceability/%E4%BA%A7%E5%93%81%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xls" download="产品导入模板.xls" target="view_window">下载产品编码模板文件</a>
           </div>
           <div class="specialText">（注：适用于没有部署云MES的水泵企业）</div>
           <el-button type="primary" round size="small" @click="onClickClearButton">清空</el-button>
           <el-button type="primary" round size="small"  :class="isSumbit?'':'dis-btn'" @click="onClickSubmit">立即生成</el-button>
         </div>

        </el-row>

      </el-form>
    </div>
    <div v-loading="listLoading">
      <div v-if="tableData.length">
        <el-table
            :data="tableData"
            border>
          <el-table-column
              type="index"
              align="center"
              width="40">
          </el-table-column>
          <el-table-column
              prop="waterPumpCode"
              show-overflow-tooltip
              align="center"
              width="250"
              label="水泵码">
          </el-table-column>
          <el-table-column
              prop="enterpriseCode"
              show-overflow-tooltip
              align="center"
              label="企业码">
          </el-table-column>
          <el-table-column
              prop="productCode"
              show-overflow-tooltip
              align="center"
              label="产品码"
              width="120">
          </el-table-column>
          <el-table-column
              prop="serialNumber"
              show-overflow-tooltip
              align="center"
              label="序列号"
              width="100">
          </el-table-column>
          <el-table-column
              prop="createDate"
              show-overflow-tooltip
              align="center"
              label="创建时间"
              width="200">
          </el-table-column>
        </el-table>
        <el-pagination
            style="margin-top: 20px;"
            @current-change="onChangeCurrent"
            :current-page="queryParams.current"
            :page-size="queryParams.pageSize"
            background
            layout="total, prev, pager, next"
            :total="queryParams.total">
        </el-pagination>
      </div>
      <div v-else style="text-align:center;margin:20px 0">
        <img src="../../assets/nosearchMesg.jpg" alt="" style="width:200px">
      </div>
      <div class="generate-page">
        <el-button type="primary" size="small" round @click="onChangePage(0)">
          上 一 步
        </el-button>
        <el-button type="primary" size="small" round :disabled="!tableData.length" @click="onChangePage(1)">
          下 一 步
        </el-button>
      </div>
    </div>
    <product-info v-if="showInfo"/>

    <el-dialog
        :visible.sync="dialogVisible"
        title="是否修改产品码"
        lock-scroll
        append-to-body
        width="435px"
        style="margin-top: 18vh;"
    >
      <div class="dialog-info-box">
<!--        <span style="text-align:left;margin:20px;font-size: 16px;"></span>-->
        <el-form :model="dialogProductForm"
                 label-width="100px" style="margin-top: 20px">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="产品编码">
                <el-input v-model="dialogProductForm.productNo" style="width: 200px;"
                          placeholder="请输入产品编码"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="onProductNoSubmit()">
            提交
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>

import {
  deleteTranslationDetail, getEnterprise, makeAutoList,
  queryCodeTraceabilityTranslationList,
  sendCodeTraceabilityTranslationType
} from "../../utils/interface";
import ProductInfo from "./reversoProductInfo";

export default {
  components: {
    ProductInfo,
  },
  data() {
    return {
      headers: {
        'Authorization': 'Bearer ' + this.$cookies.get("api_access_token")	//	可以是授权凭证用的参数值
      },
      showInfo: false,
      tableData: [],
      tableAllData: [],
      productData: {},
      qrStatus: '1',
      uploadUrl: "",
      uploadDisabled: false,
      queryParams: {
        enterpriseUuid: '',
        productCode: '',
        mainUuid: '',
        current: 1,
        pageSize: 20,
        total: 0,
      },
      dialogCodeForm: {
        excelFile: "",
      },
      enumStatus: [{
        value: 'INIT',
        name: '未审核',
      }, {
        value: 'REVIEW',
        name: '已审核',
      }, {
        value: 'NOT_PASS',
        name: '审核不通过',
      }, {
        value: 'REVIEW_PASS',
        name: '审核通过',
      }, {
        value: 'FINISH',
        name: '已生成',
      },],
      listLoading: false,
      dialogVisible:false,
      isSumbit:true,
      dialogProductForm: {
        productNo:""
      }
    };
  },
  created() {
    if (null != this.$route.query.productUuid) {
      this.uploadDisabled = true
    }
  },
  methods: {
    initData(product) {
      this.productData = product
      this.queryParams.enterpriseUuid = product.enterpriseUuid
      this.queryParams.productCode = product.productCode
      this.queryParams.mainUuid = product.uuid
      this.uploadUrl = "/api/resource-tendering/api/v1/translation/detail/uploadExcel/" + product.uuid
      this.qrStatus = '1'
      this.getPageList()
      this.getOptionsData()
    },
    getPageList() {
      this.listLoading = true
      sendCodeTraceabilityTranslationType(this.productData.uuid, this.qrStatus).then((type) => {
        this.tableAllData = type.data
        queryCodeTraceabilityTranslationList(this.queryParams).then((res) => {
          this.listLoading = false
          if (res.list) {
            this.tableData = res.list
            this.queryParams.total = res.total
          }
        }).catch(err => {
          this.listLoading = false
        })
      }).catch(err => {
        this.listLoading = false
      })

      getEnterprise().then((res) => {
        if (res.data) {
          this.dialogProductForm.productNo =res.data.productNo
        }
      })
    },
    onInputChange() {
      this.$nextTick(() => {
        this.getPageList()
      })
    },
    getOptionsData() {

    },

    onChangePage(type) {
      if (type === 0) {//上一步
        this.$emit('onChangeStep', 1, this.productData)
      } else {//下一步
        this.$emit('onChangeStep', 3, this.productData, {waterPumpList: this.tableAllData})
      }
    },
    onClickClear() {
      this.$refs['refGenerateForm'].resetFields()
      this.queryParams = {
        current: 1,
        pageSize: 20,
        total: 0,
      }
      this.getPageList()
    },
    onClickClearButton() {
      this.$refs['refGenerateForm'].resetFields()
      this.queryParams.enterpriseUuid = this.productData.enterpriseUuid
      this.queryParams.productCode = this.productData.productCode
      this.queryParams.mainUuid = this.productData.uuid
      this.$refs.upload.clearFiles()
      deleteTranslationDetail(this.productData.uuid).then((type) => {
        this.getPageList()
      }).catch(err => {
        this.listLoading = false
      })
    },
    onClickSubmit(){
      this.dialogVisible = true;
    },
    onProductNoSubmit(){
      this.dialogVisible = false;
        const regex = /^[A-Z]{1,5}$/;
        if (regex.test(this.dialogProductForm.productNo)){
          this.isSumbit = false;
          makeAutoList(this.queryParams.mainUuid,this.dialogProductForm.productNo).then((res) => {
            this.getPageList()
          }).catch(err => {
            this.listLoading = false
          })
        }else{
          this.$message.error('请输入1-5位大写字母组成的新编码')
          return false
        }



    },
    onChangeCurrent(e) {
      this.queryParams.current = e
      this.getPageList()
    },
    eachDictName(status) {
      return this.enumStatus.find(item => item.value === status).name
    },
    handlePreviewDownload(file) {
      let a = document.createElement('a')
      a.href = file.url
      a.download = file.name //同源策略限制无法生效
      a.click()
    },
    handleQualityAptitudeRemove(file, fileList, key) {
      this.dialogCodeForm[key] = []
      for (const item of fileList) {
        //新上传的文件
        if (item.response !== undefined) {
          this.dialogCodeForm[key].push({
            url: item.response.url,
            name: item.name,
          })
        } else {//已经上传的文件
          this.dialogCodeForm[key].push({
            url: item.url,
            name: item.name,
          })
        }
      }
    },
    handleBeforeUpload(file) {
      const uploadLimit = 1
      const uploadTypes = ['xlsx', 'xls']
      const filetype = file.name.replace(/.+\./, '')
      const isRightSize = (file.size || 0) / 1024 / 1024 < uploadLimit
      if (!isRightSize) {
        this.$message.error('文件大小超过 ' + uploadLimit + 'MB')
        return false
      }

      if (uploadTypes.indexOf(filetype.toLowerCase()) === -1) {
        this.$message.warning({
          message: '请上传后缀名为xlsx、xls文件'
        })
        return false
      }

      return true
    },
    handleQualityAptitudeSuccess(response, file, fileList, key) {
      this.dialogCodeForm[key] = []
      for (const item of fileList) {
        console.log("====key======" + key)
        console.log("====item.response======")
        console.log(item.response)
        //新上传的文件
        if (item.response.success) {
          this.dialogCodeForm[key].push({
            url: item.response.url,
            name: item.name,
          })
        } else {//已经上传的文件
          this.dialogCodeForm[key].push({
            url: item.url,
            name: item.name,
          })
        }
      }
      if (response.success) {
        sendCodeTraceabilityTranslationType(this.productData.uuid, this.qrStatus).then((type) => {
          this.tableAllData = type.data
          queryCodeTraceabilityTranslationList(this.queryParams).then((res) => {
            this.listLoading = false
            if (res.list) {
              this.tableData = res.list
              this.queryParams.total = res.total
            }
          }).catch(err => {
            this.listLoading = false
          })
        }).catch(err => {
          this.listLoading = false
        })
      } else {
        this.$message.warning({
          message: response.message
        })
      }

    },
    downloadExcel() {
      console.log("==========")
      console.log(this.$route)
      window.open('../../assets/codeTraceability/产品导入模板.xls')
      // let a = document.createElement('a');
      // a.href ="../../assets/codeTraceability/产品导入模板.xls"
      // a.click();
    },
    onChangeFile(file, fileList) {
      if (fileList.length > 0) {
        this.fileList = [fileList[fileList.length - 1]]//这一步，是 展示最后一次选择文件
      }
    },
  },
};
</script>

<style scoped lang="less">
.specialText {
  font-size: 14px;
  color: red;
  margin-left: 30px;
}

.span-line{
  font-size: 14px;color: #009999;
}

.span-line:hover {
  text-decoration: underline;
  font-size: 14px;color: #009999;
}


.generate-code-list {
  .generate-page {
    margin: 50px auto;
    width: 35%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  /deep/ .el-button--small.is-round {
    padding: 9px 26px;
  }

  /deep/ .el-form-item__content {
    width: calc(100% - 100px);
  }

  /deep/ .el-form--inline .el-form-item {
    width: 100%;
  }

  /deep/ .el-upload {
    display: inline-flex;
  }

  /deep/ .el-icon-upload {
    line-height: 40px;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/codeTraceabilityOther/reversoGenerateCodeList.vue